<header class="header">
  <nav role="navigation" [attr.aria-label]="'nav.user.description' | translate" class="container navbar navbar-expand-md px-0">
    <div class="d-flex flex-grow-1">
      <!-- Updated logo to CUEA -->
      <a class="navbar-brand m-2" routerLink="/home">
        <img src="https://cuea.edu/wp-content/uploads/2025/03/CUEA-LOGO-copy-1-1.png" [attr.alt]="'menu.header.image.logo' | translate" class="cuea-logo"/>
      </a>
    </div>
    <div class="navbar-buttons d-flex flex-grow-1 ml-auto justify-content-end align-items-center gapx-1">
      <ds-themed-search-navbar></ds-themed-search-navbar>
      <ds-themed-lang-switch></ds-themed-lang-switch>
      <ds-context-help-toggle></ds-context-help-toggle>
      <ds-themed-auth-nav-menu></ds-themed-auth-nav-menu>
      <ds-impersonate-navbar></ds-impersonate-navbar>
      <div class="pl-2">
        <button class="navbar-toggler" type="button" (click)="toggleNavbar()"
                aria-controls="collapsingNav"
                aria-expanded="false" [attr.aria-label]="'nav.toggle' | translate">
          <span class="navbar-toggler-icon fas fa-bars fa-fw" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </nav>
  <!-- Custom Navbar for CUEA -->
  <ds-themed-navbar></ds-themed-navbar>
</header>
